import { render, staticRenderFns } from "./ConsumptionPieChart.vue?vue&type=template&id=4d6d2b6e"
import script from "./ConsumptionPieChart.vue?vue&type=script&lang=js"
export * from "./ConsumptionPieChart.vue?vue&type=script&lang=js"
import style0 from "./ConsumptionPieChart.vue?vue&type=style&index=0&id=4d6d2b6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports